import { TemplateRef, ViewContainerRef, Input, Directive } from '@angular/core';

@Directive({
  selector: '[pgFieldGridColumn], [gritFieldGridColumn]',
})
export class PgFieldGridColumnDirective {
  @Input() pgFieldGridColumn;

  get width() {
    return this.pgFieldGridColumn || 'auto';
  }

  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainer: ViewContainerRef
  ) {}
}
